import React, { Component } from 'react';
import {getCategoriesByRestaurant, getRestaurant, checkSchedules, getFoodByRestaurant, checkAllowOrder0s ,getFieldsByRestaurant} from '../restaurantDB';
import $ from 'jquery';
import ModalFood from './ModalFood';
import moment from 'moment'
import Cart from './Cart';
import {getCartByUser} from '../cartDB';
import {Alert,Popover ,OverlayTrigger } from 'react-bootstrap'
import ModalConnection from './ModalConnectionSubscribe';
import ReactLoading from "react-loading";
import Notification from 'rc-notification';
import 'rc-notification/assets/index.css';
import {doSignOut} from '../authDB';


const catika=["breakfast","lunch","dinner","dessert","dessert","dessert","dessert","dessert","dessert"]
// id dev
//const idRestaurant="-LHCvfvi5Zis0rJffGlg"
// id prod
const idRestaurant="-L8HPl47r9qChaUm_6uU"


let notification = null;
Notification.newInstance({}, (n) => notification = n);

class App extends Component {
    constructor(props) {
        super(props);
        this.state={
            start_field:true,
            start_categorie:true,
            categories:[],
            fields:[],
            logo:"",
            photo:"",
            food:[],
            initialItems:[],
            cat:"",
            open:false,
            opened:false,
            foodi:[,{options:{},extras:{}}],
            foodCart:{}
        }
      }
      show_connection(){
        this.refs.ModalConnection.handleShow();
    console.log(this.refs)
    }
    Deconx(){
      localStorage.removeItem('user')
      doSignOut().then(()=>{
        window.parent.location = window.parent.location.href;
    
      })
    }
    componentDidMount(){

        checkSchedules(idRestaurant , (schedules) => {
            var today = new Date();
            var yesterday= new Date(today.getTime() - (24 * 60 * 60 * 1000));
            var currentTimeZoneOffsetInHours = today.getTimezoneOffset() / 60;
            var res =true
            if(schedules.val()){
                res=false
              var days = Object.values(schedules.val())[0].days.split(",");
            //  if(days.includes(moment().format('dddd').toLowerCase())){
                var start_timeUTC = Object.values(schedules.val())[0].start_time;
                var end_timeUTC = Object.values(schedules.val())[0].end_time;
                var start_time = moment(start_timeUTC, "LT").subtract(currentTimeZoneOffsetInHours,'h').format("LT");
                var end_time = moment(end_timeUTC, "LT").subtract(currentTimeZoneOffsetInHours,'h').format("LT");
               if( moment(end_time, "LT").isAfter(moment(start_time, "LT"))   ){
                   console.log("classic")
                   console.log( moment(today).format('dddd').toLowerCase())

                   if((moment().isAfter(moment(start_time, "LT"))) && (moment(end_time, "LT").isAfter(moment()))){
                    if(days.includes(moment().format('dddd').toLowerCase())){res=true}
                   }

                   console.log("is open:"+res)


               }
               else{
                console.log("2 zone")
                console.log( moment(yesterday).format('dddd').toLowerCase())


                if( moment(end_time, "LT").isAfter(moment())){
                    if(days.includes(moment(yesterday).format('dddd').toLowerCase())){res=true}
                    
               }
               if( moment(start_time, "LT").isBefore(moment())){
                if(days.includes(moment().format('dddd').toLowerCase())){res=true}
                
           }
console.log("is open:"+res)
        }
                
             
             
            }
            else {
              this.setState({state : {open : 'Ouvert', schedule : '24/7'}});
              console.log('Ouvert  24/7 :'+start_time)

            }
            console.log("is open:"+res)
            this.setState({opened:res})

          });

        if(localStorage.getItem('user')){
            getCartByUser(JSON.parse(localStorage.getItem('user')).uid, idRestaurant, (cart) => {
              if(cart.val()){
                this.setState({
                  cart: true, foodCart : cart.val()
                });
                console.log( JSON.parse(localStorage.getItem('user')).uid)
              }
              else{
                console.log('non');
                this.setState({
                  cart: false,foodCart : {}
                });
              }
            });
          }
        getCategoriesByRestaurant(idRestaurant).then((categories) => {
            this.setState({categories : Object.entries(categories.val())});
          }).catch((error) => {
            console.log(error);
          });
          getFieldsByRestaurant(idRestaurant).then((fields) => {
            this.setState({fields : Object.entries(fields.val())});
          }).catch((error) => {
            console.log(error);
          });
      
          getRestaurant(idRestaurant).then((restaurant) => {
            if(restaurant.val()){
              this.setState({restaurant : restaurant.val()});
              if(this.state.restaurant.logo.url){
                this.setState({logo : this.state.restaurant.logo.url});
              }
              if(this.state.restaurant.photo.url){
                this.setState({photo : ''+this.state.restaurant.photo.url});
              }
            }
            else {
              window.parent.location = "/";
            }
          }).catch((error) => {
            console.log(error);
          });
      
          getFoodByRestaurant(idRestaurant, (food) => {
            if(food.val()){
              this.setState({initialItems : Object.entries(food.val())});
              this.setState({food: this.state.initialItems});
            }
          });
    }

  categories_accepted()
  {
     
      var food=this.state.food
      var categories=this.state.categories
      var fields=this.state.fields
      var field_disp=[]
      var cat_disp=[]
      var product_disp=[]

      for(var i=0;i<categories.length;i++ )
{ 
   
    cat_disp={...cat_disp,[categories[i][0]]:false}


}
for(var i=0;i<fields.length;i++ )
{ 
   if(fields[i][1].is_active)
    field_disp={...field_disp,[fields[i][0]]:true}
    else
    field_disp={...field_disp,[fields[i][0]]:false}



}





      Object.keys(food||[]).forEach((v,e)=>{
       
          if(food[v][1].available){
              
            cat_disp={...cat_disp,[food[v][1].category_id]:true}
            product_disp={...product_disp,[food[v][0]]:true}
          }
          else{
            product_disp={...product_disp,[food[v][0]]:false}
          }
      })


      return [{...cat_disp},{...product_disp},{...field_disp}]
  }

  fields_list(){
    var field_dispo=this.categories_accepted()[2]
      

    var items=[]
var fields=this.state.fields
var field=this.state.field

if(this.state.start_field){
    this.setState({start_field:false,field:fields[0][0]})
}
for(var i=0;i<fields.length;i++ )
{ 
    let id=fields[i][0]
    
    
if(field_dispo[id])
  items.push(<li className={(field===id)?"filter-button active":"filter-button"} onClick={()=>{this.setState({field:id,start_categorie:true})}} key= {i} data-filter={"."+catika[i]}>
  
  <i ></i>
  {"  "+fields[i][1].name
  }</li>)  


}


return items

}

  



category_list(){
var items=[]
var cat_dispo=this.categories_accepted()[0]
var categories=this.state.categories
var cat=this.state.cat


for(var i=0;i<categories.length;i++ )
{ 
    let id=categories[i][0]
    
    
    if(cat_dispo[id] && (categories[i][1].field_id=== this.state.field) )
  {
    if(this.state.start_categorie){
        this.setState({start_categorie:false,cat:id})
    }

      items.unshift(<li className={(cat===id)?"filter-button active":"filter-button"} onClick={()=>{this.setState({cat:id})}} key= {i} data-filter={"."+catika[i]}>
  <img height={20} width={23} src={categories[i][1].icon.url}/>
  <i ></i>
  {"  "+categories[i][1].name
  }</li>)  }


}


return items

}


food_list(){
    var items=[]
    var food=this.state.food
    var cat=this.state.cat
 var food_dispo=this.categories_accepted()[1]
    for(var i=0;i<food.length;i++ )
    { 
        let id=food[i][0]
        
        let foodi=food[i]
        if(cat===""&& food_dispo[id])
        
     {
        const popoverRight = (
            <Popover id="popover-positioned-right" title={food[i][1].name}>
              <p>{food[i][1].description}</p>
            </Popover>
          );

          items.push(
      
        <div key= {i+100} style={{margin:"5px 5px 5px 10px", boxShadow:" 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)"}}  className={" col-xs-5 col-sm-5 col-md-5 col-lg-5 "+catika[i]}>
        <div className="menu-box">
  
        <OverlayTrigger trigger="click" placement="right" overlay={popoverRight}>
                <img src={(food[i][1].main_image)?food[i][1].main_image.url:this.state.logo} alt="menu pic" className="featured-pic"/>
                </OverlayTrigger>
            <div className="menu-title" style={{marginTop:10}}>
                <h5 className="title bg-secondry">
                     {food[i][1].name}
                </h5>
             {(!food[i][1].is_price_hidden)?<span>
                    {food[i][1].price.toFixed(2)} TND
                </span>:<span/>}
            </div>
            <p style={{ whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis'}}>{food[i][1].description}</p>
  {(!food[i][1].is_price_hidden)?<button class='btn' style={{float:"right",backgroundColor:"#ffad18",color:"#ffffff"}}  onClick={()=>{
this.setState({open:{[id]:true,foodi:foodi}})
this.showModal(id)
  }
} >commande</button>:<div/>}
      <ModalFood ref={id} id={idRestaurant} food = {foodi} show = {this.state.open} currency = {'TND'} addToCart = {this.props.addToCart}/>

        </div>
    </div>
    

     
    
    
    )  }
    else
    {
        const popoverRight = (
            <Popover id="popover-positioned-right" title={food[i][1].name}>
              <p>{food[i][1].description}</p>
            </Popover>
          );

if(cat===food[i][1].category_id && food_dispo[id])
        items.push(
      
            <div key= {i+100} style={{margin:"10px 10px 10px 10px", boxShadow:" 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)"}}  className={"col-xs-5 col-sm-5 col-md-5 col-lg-5 "+catika[i]}>
            <div className="menu-box">
      
            <OverlayTrigger trigger="click" placement="right" overlay={popoverRight}>
                    <img src={(food[i][1].main_image)?food[i][1].main_image.url:this.state.logo} alt="menu pic" className="featured-pic"/>
                    </OverlayTrigger>
                <div className="menu-title" style={{marginTop:10}}>
                    <h5 className="title bg-secondry">
                         {food[i][1].name}
                    </h5>
                    <span>
                        {food[i][1].price.toFixed(2)} TND
                    </span>
                </div>
                <p style={{ whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'}}>{food[i][1].description}</p>
      <button class='btn' href="/order" style={{float:"right",backgroundColor:"#ffad18",color:"#ffffff"}} onClick={()=>{
this.setState({open:{[id]:true,foodi:foodi}})
this.showModal(id)
  }
} >commande</button>
 <ModalFood ref={id} id={idRestaurant} food = {foodi} show = {this.state.open} currency = {'TND'} addToCart = {this.props.addToCart}/>
            </div>
        </div>
        
    
         
        
        
        ) 

    }
    
    
    }
    
    
    return items
    
    }
    showModal(id) {
        if(localStorage.getItem('user')){
          this.refs[id].handleShow();
        }
        else {
          this.refs.ModalConnection.handleShow();
        }
      }

  render() {
   
     
    console.log(this.state)
    console.log(this.categories_accepted())

    
    return (
   <div>
         <header className="header">
            <div className="container">
                <div className="menubar">
                    <div className="row">
                        <div className="col-md-12">
                            <nav className="navbar navbar-static-top">
                             <div className="navbar-header">
                                    <button type="button" className="navbar-toggle collapsed" data-toggle="collapse" aria-expanded="false">
                                        <span className="sr-only">Toggle navigation</span>
                                        <span className="icon-bar"></span>
                                        <span className="icon-bar"></span>
                                        <span className="icon-bar"></span>
                                    </button>
                                    <a className="navbar-brand" href="/">
                                        <img src="/images/logo.png" className="img-responsive" alt="logo"/>
                                    </a>
                                </div>                      
     <div className="collapse navbar-collapse ">
                                    <ul className="nav navbar-nav navbar-right">
                                    
                                    <li className="res-btn">
                                          {(JSON.parse(localStorage.getItem('user')))?  <button onClick={()=>this.Deconx()} className="book-btn">Déconnection</button>:<button onClick={()=>this.show_connection()} className="book-btn">Connexion</button>}
                                    </li>
                                    </ul>
                                    <ul className="nav navbar-nav navbar-right" id="main-menu">

                                    <li className="">

                                         <a  href="/">
                                                Accueil
                                         </a>
                                    </li>
                                    {/*    <li className="">
                                            <a  href="/about">À propos</a>
    </li>*/}
                                        <li className="active">
                                            <a  href="/order">Menu</a>                                          
                                        </li>
                                        {(JSON.parse(localStorage.getItem('user')))?  <li className="">
                                            <a  href="/historique">Historique</a>
                                        </li>:null       }     
                                        {(JSON.parse(localStorage.getItem('user')))?   <li className="">
                                            <a href="/loyalty">
                                            Fidélité
                                            </a>
                                        </li>  :null       } 
                                        <li className="">
                                            <a   href="/Blog">
                                                Blog
                                            </a>
                                        </li>     
                                                          
                                        <li className="">
                                            <a   href="/contact">
                                                Contact
                                            </a>
                                        </li>  
                                                                           
                                    </ul>
                                </div>  
                            </nav>
                        </div>
                    </div>
                </div>

            </div>
            <div className="mobile-menu" data-logo="/images/logo.png">


            </div>



        </header>
        <section className="page-title">
    <div className="container">
        <h2 className="title">
            Menu
        </h2>
        <ul className="brdcrumb clearfix">
            <li>
                <a href="/">Accueil</a>
            </li>
         
            <li className="current">
               Menu
            </li>
        </ul>
    </div>
</section>

<section className="food-menu-section food-bg section-padding">
    <div className="container">
{(Object.keys( this.state.food).length>0 && Object.keys(this.state.categories).length>0 )?<div className="row">
                      <div className="col-xs-8 col-sm-8 col-md-8 col-lg-8">
    {     (!(this.state.opened===true))?<Alert bsStyle="danger" >
   Restaurant fermé 
        </Alert>:<div/>}
        <ul className="menus sort-drinks">      
{this.fields_list()}
        </ul>
        <br/>
        <ul className="menus sort-drinks">      
{this.category_list()}
        </ul>
        <div className="row ">     
           {this.food_list()}
        </div>
</div>
<div className="col-xs-4 col-sm-4 col-md-4 col-lg-4">
<Cart cart = {this.state.foodCart} open={this.state.opened} currency = "TND" name="hhhhhhh" idRestaurant ={idRestaurant} />
</div>
</div> :<center><ReactLoading type="spin" color="#000000" /></center> }
    </div>
</section>
<section className="call-out-section section-padding">
    <div className="container">
        <div className="row">
            <div className="col-md-10">
                <h2>Découvrez le vrai goût de nos Plats.</h2>
            </div>
            <div className="col-md-2">
                <div className="call-out-btn">
                    <a href="/contact" className="btn-custom">Contactez nous</a>
                </div>
            </div>
        </div>
    </div>
</section>

<ModalConnection ref="ModalConnection"/>   
    </div>  
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/container/food-menu.js